module.exports = __webpack_public_path__ + "static/img/bg.bba8a3f7.png";